import React from 'react'
import Card from 'shared/Card'
import { useCreateGuestSession } from 'components/sessions/queries'
import EvenlySpaced from 'shared/content-control/EvenlySpaced'
import Form from 'react-bootstrap/Form'
import FormControl from 'shared/FormControl'
import { useForm } from 'react-hook-form'
import { PrimaryButton } from 'shared/Buttons'
import { useSessionContext } from 'components/sessions/sessionContext'
import GameContainer from 'components/play/GameContainer'

const CreateGuestSession = () => {
  const {
    formState: { isSubmitting },
    handleSubmit,
    register,
  } = useForm()

  const [createGuestSession] = useCreateGuestSession()
  const { persistSession } = useSessionContext()

  const onSubmit = handleSubmit(async ({ firstname }) => {
    try {
      const {
        data: {
          createdGuestSession: { error, ...session },
        },
      } = await createGuestSession({ variables: { firstname } })
      if (!error) persistSession(session)
    } catch (e) {
      console.error(`createGuestSession submit error: ${e}`)
    }
  })
  return (
    <GameContainer>
      <EvenlySpaced.Column>
        <Card>
          <Card.Body>
            <h1>What is your name?</h1>
            <Form
              disabled={isSubmitting}
              inline
              onSubmit={onSubmit}
              style={{
                marginTop: '1rem',
                display: 'flex',
                flexFlow: 'row nowrap',
              }}
            >
              <FormControl
                name="firstname"
                ref={register()}
                style={{ flexGrow: 1, marginRight: '1rem' }}
                type="text"
                placeholder="e.g. Alice"
                autoFocus
                disabled={isSubmitting}
                autoComplete="off"
              />
              <PrimaryButton type="submit" disabled={isSubmitting}>
                Send
              </PrimaryButton>
            </Form>
          </Card.Body>
        </Card>
      </EvenlySpaced.Column>
    </GameContainer>
  )
}

export default CreateGuestSession
